import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoConfiguracionOpEditarConfirmarModalidadRegistrosPatronalesComponent {
  onClose
  item
  registrosPatronales
  registrosPatronalesDestino
  data = {}


  $onInit() {
    this.data.registroPatronalOrigenId = this.item.registroPatronalId
    this.registrosPatronalesDestino = this.registrosPatronalesDestino.filter(i => i.clasePrimaDeRiesgo === this.item.clasePrimaDeRiesgoId)

    if(this.registrosPatronalesDestino.length === 1) {
      this.data.registroPatronalDestinoId = this.registrosPatronalesDestino[0].id
      this.finalizar();
    }
  }

  finalizar() {
    this.onClose({
      $event: {
        data: {
          registroPatronalIdOrigen: this.data.registroPatronalOrigenId,
          registroPatronalIdDestino: this.data.registroPatronalDestinoId,
        },
      },
    })
  }

  cancelar() {
    this.onClose()
  }
}

module.component('fanProyectoConfigOpEditarConfirmarModalidadRegistroPatronales', {
  controller: FanProyectoConfiguracionOpEditarConfirmarModalidadRegistrosPatronalesComponent,
  template: template,
  bindings: {
    item: '<',
    registrosPatronales: '<',
    registrosPatronalesDestino: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/configuracion/op/editar/confirmar/modalidad/registrosPatronales/component.js